var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_Page"},[_c('div',{staticClass:"cinwin"}),_c('ul',{ref:"loading",staticClass:"loading"},_vm._l((8),function(spot,index){return _c('li',{key:index,staticClass:"spot"},[_c('span',{staticClass:"spot-wrapper",style:({ background: _vm.spotColor })})])}),0),_c('span',{staticClass:"nkdk"},[_vm._v(_vm._s(_vm.loadname))])])
}
var staticRenderFns = []

export { render, staticRenderFns }